import { createFileRoute } from '@tanstack/react-router'

import { feedbackFormParamsSchema } from '@/pages/feedback-forms/feedback-form-params'

// The per-form segment, with no guard of its own: the builder below it is a
// write route, and a later read-only page (the results) sits beside it.
export const Route = createFileRoute('/_layout/feedback-forms/$formId')({
  params: {
    parse: (raw) => feedbackFormParamsSchema.parse(raw),
    stringify: ({ formId }) => ({ formId: String(formId) }),
  },
})
